<template>
  <div v-if="progressBarValues">
    <p class="text-muted">
      <strong>
        Database Capacity - {{ campaignRecordsRemaining.limit | number }} Limit
      </strong>
    </p>
    <stacked-progress-bar :values="progressBarValues" />
  </div>
</template>
<script>
import StackedProgressBar from '../Common/StackedProgressBar'
import { campaignRecordsRemainingQuery } from '../../graphql/campaign'

export default {
  components: {
    StackedProgressBar
  },
  apollo: {
    campaignRecordsRemaining: {
      query: campaignRecordsRemainingQuery,
      fetchPolicy: 'network-only'
    }
  },
  computed: {
    progressBarValues () {
      if (!this.campaignRecordsRemaining) {
        return null
      }
      const counts = this.campaignRecordsRemaining
      let limit = counts.limit
      if (!limit) {
        return null
      }
      // if the limit is less than the totals, we'll increase the limit, for the sake of creating percentage segments
      if (limit < (counts.remaining + counts.added)) {
        limit = counts.remaining + counts.added
      }
      // what percent is remaining?
      let remainingPercent = Math.floor((counts.remaining / limit) * 100)
      // what percent have been added?
      let activePercent = Math.ceil((counts.added / limit) * 100)
      // subtract the deleted, so it gets its own segment
      let deletedPercent = Math.ceil((counts.deleted / limit) * 100)
      activePercent = activePercent - deletedPercent
      // if any value is very low, we'll still give it a sliver
      activePercent = activePercent < 2 ? 2 : activePercent
      deletedPercent = deletedPercent > 0 && deletedPercent < 2 ? 2 : deletedPercent
      // adjust the balance with the remaining percent
      const adjustPercent = 100 - (remainingPercent + activePercent + deletedPercent)
      remainingPercent = remainingPercent + adjustPercent
      // build the values
      // let contactsCount = limit - counts.remaining - counts.deleted
      // contactsCount = contactsCount < 0 ? 0 : contactsCount
      const results = [
        {
          color: 'primary',
          percent: activePercent,
          // label: contactsCount > 1 ? this.$options.filters.number(contactsCount) : null,
          legend: 'Active'
        }
      ]
      if (deletedPercent > 0) {
        results.push({
          color: 'warning',
          percent: deletedPercent,
          // label: counts.deleted > 1 ? this.$options.filters.number(counts.deleted) : null,
          legend: 'Deleted'
        })
      }
      results.push({
        color: 'success',
        percent: remainingPercent,
        // label: counts.remaining > 1 ? this.$options.filters.number(counts.remaining) : null,
        legend: `${this.$options.filters.number(counts.remaining)} Remaining Contacts`
      })
      return results
    }
  }
}
</script>
